import { mdiEmailSync } from "@mdi/js";

const autoEmailReportNav = [
  {
    title: "Rapport Mail Auto",
    icon: mdiEmailSync,
    to: "auto-email-report-prog",
    resource: "programmatique",
    action: "manage",
  },
];

export default autoEmailReportNav;
